import React, { useState } from "react";
import { toast } from "react-toastify";
import { instance as axios } from "../../../utils/axiosConfig";

function AppSecurity({ appId }) {
  const [keyGenerated, setKeyGenerated] = useState(false);
  const [api_key, setKey] = useState("");
  return (
    <div>
      <h1 className="text-sm md:text-md font-medium leading-5 my-4">
        An API key helps us authenticate requests that you make to our APIs.
      </h1>
      <h1 className="text-sm md:text-md font-medium leading-5">
        Please record the value that you generate for later user as you will not
        see it from this dashboard on subsequent visits
      </h1>
      <div className="max-w-xl border mx-auto my-4 p-3 ">
        {keyGenerated ? (
          <KeyGenerated api_key={api_key} />
        ) : (
          <PassForm
            setKeyGenerated={setKeyGenerated}
            appId={appId}
            setKey={setKey}
          />
        )}
      </div>
    </div>
  );
}

function PassForm({ setKeyGenerated, appId, setKey }) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const handleGenerate = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const resp = await axios.post("/generate-key", {
        password,
        app_id: appId,
      });
      // console.log(resp.data);
      setKey(resp.data.key);
      toast.success("key generated");
      setKeyGenerated(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error.response.data);
    }
  };

  return (
    <form onSubmit={handleGenerate}>
      <div className="mb-6">
        <label
          htmlFor="password"
          className="block mb-2 text-sm font-medium text-gray-900 "
        >
          Your password
        </label>
        <input
          type="password"
          id="password"
          className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
          placeholder="your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        className="text-yellow-900 bg-yellow-400 opacity-80 hover:bg-yellow-300 focus:ring-3 focus:outline-none focus:ring-yellow-800 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
      >
        {loading ? (
          <h1 className="animate-bounce">Generating key...</h1>
        ) : (
          "Generate"
        )}
      </button>
    </form>
  );
}

function KeyGenerated({ api_key }) {
  const handleCopy = () => {
    navigator.clipboard
      .writeText(api_key)
      .then(() => {
        toast.success("key copyed to clipboard");
      })
      .catch((err) => {
        alert("copying failed");
      });
  };

  return (
    <div>
      <div className="mb-6">
        <label htmlFor="key" className="block mb-4 text-sm font-medium ">
          Copy generated key
        </label>
        <input
          type="text"
          id="key"
          className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
          // placeholder="your password"
          value={api_key}
          required
          disabled
        />
      </div>
      <button
        onClick={handleCopy}
        className="text-yellow-900 bg-yellow-400 opacity-80 hover:bg-yellow-300 focus:ring-3 focus:outline-none focus:ring-yellow-800 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
      >
        Copy
      </button>
    </div>
  );
}

export default AppSecurity;
